import {SCENE_STATE, SceneStateManager} from "../components/state/sceneStateManager";
import {Input} from "../components/state/input";
import {clamp01} from "../engine/utils/math";
import {PumpToInput} from "../components/state/pumpToInput";
import {AppState} from "../app";
import {CrankToInput} from "../components/state/crankToInput";
import random from "../engine/random/random";
import {settings} from "../settings";

export function updateState({entities, time, soundEvents}: AppState) {

    entities.forEach([Input], (e) => {

        e.Input.lastInput = e.Input.input
    })

    entities.forEach([CrankToInput, Input], (e) => {


        const crank = e.CrankToInput.crankEntity
        if (!e.Input.active)
            e.CrankToInput.rotationOffset = crank.Rotation.value

        crank.Rotation.value = Math.min(crank.Rotation.value, e.CrankToInput.rotationOffset)

        e.Input.input = (crank.Rotation.value - e.CrankToInput.rotationOffset) * -e.CrankToInput.crankSpeed
    })
    entities.forEach([PumpToInput, Input], (e) => {

        if (!e.Input.active)
            e.PumpToInput.pumpEntity.PumpPressure.pressure = 0

        e.Input.input = e.PumpToInput.pumpEntity.PumpPressure.pressure * e.PumpToInput.multiplier
    })

    entities.forEach([SceneStateManager, Input], (e) => {


        e.SceneStateManager.stateTime += time.deltaTime
        switch (e.SceneStateManager.currentState) {
            case SCENE_STATE.NONE: {
                e.SceneStateManager.targetState = SCENE_STATE.INTERACTIVE

                if (settings.loop !== undefined) {
                    const loopAnimationId = settings.loop
                    console.log("infinite loop of animation " + loopAnimationId)
                    e.SceneStateManager.remainingLoops = -1
                    e.SceneStateManager.animationId = loopAnimationId
                } else {

                    e.SceneStateManager.remainingLoops = settings.noRepeat ? 0 : 1
                }

                break;
            }

            case SCENE_STATE.INTERACTIVE: {

                e.Input.input = clamp01(e.Input.input)
                if (e.Input.input >= 1) {

                    e.SceneStateManager.targetState = SCENE_STATE.FALLING
                } else {

                    if (e.Input.active) {
                        const anim = e.SceneStateManager.animations[e.SceneStateManager.animationId]
                        e.AnimationPlayer.isPlaying = false
                        const releaseFrameId = Array.isArray(anim.releaseFrameId) ? anim.releaseFrameId[e.SceneStateManager.animationSubId] : anim.releaseFrameId
                        e.AnimationPlayer.currentFrameId = Math.round(e.Input.input * (releaseFrameId - 1))
                    } else {
                        e.AnimationPlayer.isPlaying = true
                    }
                }
                break;
            }
            case SCENE_STATE.FALLING: {
                if (!e.AnimationPlayer.isPlaying) {

                    const anim = e.SceneStateManager.animations[e.SceneStateManager.animationId]
                    const subAnimStillPlaying = Array.isArray(anim.mainAnimation) && e.SceneStateManager.animationSubId < anim.mainAnimation.length-1
                    if(subAnimStillPlaying)
                    {
                        e.SceneStateManager.animationSubId++
                        e.SceneStateManager.targetState = SCENE_STATE.INTERACTIVE
                    }
                    else{

                        if (e.SceneStateManager.remainingLoops > 0)
                            e.SceneStateManager.remainingLoops--

                        if (e.SceneStateManager.remainingLoops === 0 || anim.showTransitionOnLoop)
                        {
                            e.SceneStateManager.targetState = SCENE_STATE.WAIT_FOR_TRANSITION
                        }
                        else  // quick loop of the same animation without transition
                        {
                            e.SceneStateManager.animationSubId = 0
                            e.SceneStateManager.targetState = SCENE_STATE.INTERACTIVE
                        }
                    }

                }
                break;
            }
            case SCENE_STATE.WAIT_FOR_TRANSITION: {

                if (e.SceneStateManager.stateTime > 1) {
                    e.SceneStateManager.targetState = SCENE_STATE.TRANSITION_OUT
                }
                break;
            }
            case SCENE_STATE.TRANSITION_OUT: {

                if (!e.AnimationPlayer.isPlaying) {
                    e.SceneStateManager.targetState = SCENE_STATE.TRANSITION_IN
                }
                break;
            }
            case SCENE_STATE.TRANSITION_IN: {

                if (!e.AnimationPlayer.isPlaying ) {
                    e.SceneStateManager.targetState = SCENE_STATE.INTERACTIVE
                }
                break;

            }
        }

        if (e.SceneStateManager.currentState !== e.SceneStateManager.targetState) {
            // leave
          /*  switch (e.SceneStateManager.currentState) {

                case SCENE_STATE.FALLING:

                    break

                case SCENE_STATE.TRANSITION_OUT: {

                    break
                }
            }*/

            // console.log( `${e.SceneStateManager.currentState}-> ${e.SceneStateManager.targetState} animationId=${e.SceneStateManager.animationId} animationSubId=${e.SceneStateManager.animationId}`)
            e.SceneStateManager.currentState = e.SceneStateManager.targetState
            e.SceneStateManager.stateTime = 0
            // enter
            switch (e.SceneStateManager.currentState) {

                case SCENE_STATE.FALLING:
                    e.Input.active = false
                    e.AnimationPlayer.isPlaying = true
                    break;
                case SCENE_STATE.WAIT_FOR_TRANSITION:
                    e.Input.active = false
                    e.AnimationPlayer.isPlaying = false
                    break;
                case SCENE_STATE.TRANSITION_OUT:
                    e.Input.active = false
                    e.AnimationPlayer.currentFrameId = 0
                    if (e.SceneStateManager.animations[e.SceneStateManager.animationId].transitionOutAnimation) {
                        e.AnimationPlayer.isPlaying = true
                    }
                    break;
                case SCENE_STATE.TRANSITION_IN:

                    if (e.SceneStateManager.remainingLoops === 0) {
                        e.SceneStateManager.animationId++
                        if (e.SceneStateManager.animationId > e.SceneStateManager.animations.length - 1)
                            e.SceneStateManager.animationId = 0

                        e.SceneStateManager.animationSubId = 0

                        const anim = e.SceneStateManager.animations[e.SceneStateManager.animationId]
                        const minLoopCount = 0
                        const maxLoopCount = 2
                        if (settings.noRepeat) {
                            e.SceneStateManager.remainingLoops = 0
                        } else {
                            const min = anim.minLoopCount ?? minLoopCount
                            const max = anim.maxLoopCount ?? maxLoopCount
                            e.SceneStateManager.remainingLoops = Math.floor(random.range(min, max + 1))
                        }
                    }


                    e.Input.active = false
                    e.AnimationPlayer.currentFrameId = 0
                    if (e.SceneStateManager.animations[e.SceneStateManager.animationId].transitionInAnimation) {
                        e.AnimationPlayer.isPlaying = true
                    }
                    break;
                case SCENE_STATE.INTERACTIVE:
                    e.Input.active = true
                    e.Input.value = 0
                    e.AnimationPlayer.currentFrameId = 0
                    break;
            }
        }
    })
}